package modysy.menu

import modysy.InputHandler
import modysy.datastructures.Vector2
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import org.scalajs.dom
import org.scalajs.dom.TextMetrics

class WinScreenMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Int,
    height: Int
) extends AbstractMenu(inputs, width, height) {

  private val buttonDistance = 0.095f
  private val buttonStart = 0.6f

  {
    val nextButton = new TextButton(
      width * 0.5f,
      buttonStart * height,
      "Next Level"
    )
    nextButton.fontSize = Math.round(height / 12)
    nextButton.colorSelected = Color.Gold
    nextButton.isEnabled = () => {
      stateManager.controller.numLevels > stateManager.level
    }

    nextButton.action = () => {
      stateManager.nextLevel()
    }

    val retryButton = new TextButton(
      width * 0.5f,
      (buttonStart + buttonDistance) * height,
      "Replay Level"
    )
    retryButton.fontSize = Math.round(height / 12)
    retryButton.colorSelected = Color.Gold

    retryButton.action = () => {
      stateManager.retryLevel()
    }

    val exitButton = new TextButton(
      width * 0.5f,
      (buttonStart + 2 * buttonDistance) * height,
      "Main Menu"
    )
    exitButton.fontSize = Math.round(height / 12)
    exitButton.colorSelected = Color.Gold

    exitButton.action = () => {
      stateManager.exitGame()
    }

    buttons = nextButton :: retryButton :: exitButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.endscreenWin)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {

    //ctx.fillStyle = Color.Black
    ctx.fillStyle = Color.rgba(255, 255, 255, 0.3)
    ctx.fillRect(0, 0, width, height)

    ctx.textAlign = "center"

    //val fontSize = pxtopt(height)
    ctx.font = height / 4 + "px Arial"
    ctx.fillStyle = Color.Gold
    ctx.fillText("Level cleared!", width / 2, height * 0.325, Integer.MAX_VALUE)

    super.render(ctx)
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/WinScreenMenu.scala